import { revalidateLogic, standardSchemaValidators } from '@tanstack/react-form';
import { getEstimateFormSchema } from '../schemas/estimate/estimate-form.schema.js';
import { EMPTY_FLIGHT_LEG } from '../schemas/estimate/flight-schemas.js';
import { ESTIMATE_FORM_DEFAULT_VALUES } from '../schemas/estimate/index.js';
import { useAppForm } from './use-app-form.js';
export function useEstimateForm({ defaultValues, onSubmit }) {
    return useAppForm({
        // onSubmitInvalid: ({ formApi, value }) => {
        //   console.log(value)
        //   console.log(formApi.getAllErrors())
        // },
        defaultValues: defaultValues ?? ESTIMATE_FORM_DEFAULT_VALUES,
        listeners: {
            onChange: ({ fieldApi, formApi }) => {
                const currentFlights = formApi.getFieldValue('flights');
                if (formApi.getFieldValue('type') === 'ROUND_TRIP' &&
                    ['flights[0].departure', 'flights[0].destination'].includes(fieldApi.name)) {
                    formApi.setFieldValue('flights[1].departure', currentFlights[0].destination);
                    formApi.setFieldValue('flights[1].destination', currentFlights[0].departure);
                }
                if (fieldApi.name !== 'type')
                    return;
                const newType = fieldApi.state.value;
                switch (newType) {
                    case 'MULTI_DESTINATION':
                        formApi.setFieldValue('flights', [
                            currentFlights[0] ?? { ...EMPTY_FLIGHT_LEG },
                            { ...EMPTY_FLIGHT_LEG },
                        ]);
                        break;
                    case 'ONE_WAY':
                        formApi.setFieldValue('flights', [currentFlights[0] ?? { ...EMPTY_FLIGHT_LEG }]);
                        break;
                    case 'ROUND_TRIP':
                        formApi.setFieldValue('flights', [
                            currentFlights[0] ?? { ...EMPTY_FLIGHT_LEG },
                            currentFlights[1] ?? { ...EMPTY_FLIGHT_LEG },
                        ]);
                        break;
                    default:
                        break;
                }
            },
        },
        onSubmit: async ({ value }) => {
            await onSubmit(value);
        },
        validationLogic: revalidateLogic({
            mode: 'submit',
            modeAfterSubmission: 'change',
        }),
        validators: {
            onDynamic: ({ value }) => {
                return standardSchemaValidators.validate({ validationSource: 'form', value }, getEstimateFormSchema(value.type));
            },
        },
    });
}
